import { render, staticRenderFns } from "./PopularList.vue?vue&type=template&id=1a14957d&scoped=true&"
import script from "./PopularList.vue?vue&type=script&lang=js&"
export * from "./PopularList.vue?vue&type=script&lang=js&"
import style0 from "./PopularList.vue?vue&type=style&index=0&id=1a14957d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a14957d",
  null
  
)

export default component.exports